import { render, staticRenderFns } from "./BankverbindungModal.vue?vue&type=template&id=40d40269"
import script from "./BankverbindungModal.vue?vue&type=script&lang=js"
export * from "./BankverbindungModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports